__turbopack_context__.v({
  "neutral": "tooltip-module-scss-module__pnA3WW__neutral",
  "nowrap": "tooltip-module-scss-module__pnA3WW__nowrap",
  "secondary": "tooltip-module-scss-module__pnA3WW__secondary",
  "title": "tooltip-module-scss-module__pnA3WW__title",
  "tooltip": "tooltip-module-scss-module__pnA3WW__tooltip",
});
